export default {
  methods: {
    /*
     * Generic method to remove duplicate items in a one-dimensional array
     */
    onlyUnique (value, index, self) {
      return self.indexOf(value) === index
    }
  }
}